import { render, staticRenderFns } from "./favoriteButton.vue?vue&type=template&id=05c345bc&"
import script from "./favoriteButton.vue?vue&type=script&lang=js&"
export * from "./favoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\scratch\\runner\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('05c345bc', component.options)
    } else {
      api.reload('05c345bc', component.options)
    }
    module.hot.accept("./favoriteButton.vue?vue&type=template&id=05c345bc&", function () {
      api.rerender('05c345bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/SearchNx/Scripts/ListTemplates/Components/favoriteButton.vue"
export default component.exports